//#region  Imports
import thumb19 from "./../../assets/images/videos/video19.webp";
import thumb18 from "./../../assets/images/videos/video18.webp";
import thumb17 from "./../../assets/images/videos/video17.webp";
import thumb16 from "./../../assets/images/videos/video16.webp";
import thumb15 from "./../../assets/images/videos/video15.webp";
import thumb14 from "./../../assets/images/videos/video14.webp";
import thumb13 from "./../../assets/images/videos/video13.webp";
import thumb12 from "./../../assets/images/videos/video12.webp";
import thumb11 from "./../../assets/images/videos/video11-1.webp";
import thumb10 from "./../../assets/images/videos/video10-1.webp";
import thumb8 from "./../../assets/images/videos/video8.webp";
import thumb7 from "./../../assets/images/videos/video7.webp";
import thumb6 from "./../../assets/images/videos/video6.webp";
import thumb5 from "./../../assets/images/videos/video5.webp";
import thumb4 from "./../../assets/images/videos/video4.webp";
import thumb3 from "./../../assets/images/videos/video3.webp";
import thumb2 from "./../../assets/images/videos/video2.webp";
import thumb1 from "./../../assets/images/videos/video1.webp";
import thumb9 from "./../../assets/images/videos/video9.webp";
//#endregion

export interface IVideoItem {
    youtubeId: string;
    title: string;
    thumbnail: string;
    width: number;
    height: number;
}

export const VideoItems: IVideoItem[] = [
    {
        youtubeId: "FjRbRC4wQnU",
        title: "Christmas Vibes in Milan // BMPCC4K + Tamron 70-200mm f:2 8 G2 + Viltrox EF M2",
        thumbnail: thumb19,
        width: 960,
        height: 540
    },
    {
        youtubeId: "v-S3IoG8ma0",
        title: "IL KILLER È MORTO - White Noise: voci dal carcere | Ep.01 (Explicit)",
        thumbnail: thumb18,
        width: 960,
        height: 540
    },
    {
        youtubeId: "SE1fXxCbUBc",
        title: "Learn to live in the forest - Valere kissi colorist",
        thumbnail: thumb17,
        width: 960,
        height: 540
    },
    {
        youtubeId: "ba1GFeMIED8",
        title: "Oktoberfest Munich 2022 // BMPCC 4K + Sigma 18-35mm f/1.8",
        thumbnail: thumb16,
        width: 960,
        height: 540
    },
    {
        youtubeId: "8qUuPvi3DxA",
        title: "Milena Galasso - Summerstorm (Official Video)",
        thumbnail: thumb15,
        width: 960,
        height: 540
    },
    {
        youtubeId: "bnGwFpa5YWA",
        title: "Cinematic Travel Film / Mendrisio (Shot on BMPCC4K) by Valere Kissi",
        thumbnail: thumb14,
        width: 960,
        height: 540
    },
    {
        youtubeId: "aWtVoIg2w5o",
        title: "Ermenegildo Zegna XXX Summer 2022 Fashion Show by Valere Kissi",
        thumbnail: thumb13,
        width: 480,
        height: 270
    },
    {
        youtubeId: "a88lBmD1V7o",
        title: "Emilio & Tania // Engagement Video // BMPCC 4K + CANON FD 24mm f/2.8 + DJI RS2 by Valere Kissi",
        thumbnail: thumb12,
        width: 480,
        height: 270
    },
    {
        youtubeId: "6XnaaHfTHfw",
        title: "Baye Star - Baby (Official Video) by Valere Kissi",
        thumbnail: thumb11,
        width: 960,
        height: 538
    },
    {
        youtubeId: "RlcSRlIhqts",
        title: "PAOLA // BMPCC 4K + Sigma 18-35mm f/1.8 + DJI RS2 by Valere Kissi",
        thumbnail: thumb10,
        width: 960,
        height: 540
    },
    {
        youtubeId: "Tml5U-zWpxw",
        title: "Untitled - Shot on Blackmagic Pocket Cinema Camera 4K by Valere Kissi",
        thumbnail: thumb8,
        width: 480,
        height: 270
    },
    {
        youtubeId: "JDZHce56XjI",
        title: "Trevis Porter - FVCK LOVE (Prod. Eem Triplin x PRODBYKXVI) [Official Video] by Valere Kissi",
        thumbnail: thumb2,
        width: 480,
        height: 270
    },
    {
        youtubeId: "9xB3hoqZrW4",
        title: "The Break UP // Short film by Valere Kissi",
        thumbnail: thumb7,
        width: 480,
        height: 270
    },
    {
        youtubeId: "ExhtsEZgFXI",
        title: "AXEL MERRYL VIVIANE Parody Viviane by Prince Aime by Valere Kissi",
        thumbnail: thumb3,
        width: 480,
        height: 270
    },
    {
        youtubeId: "byb0UmGsZN8",
        title: "GINEVRA: BMPCC 4K - SIGMA 17-70mm FASHION VIDEO by Valere Kissi",
        thumbnail: thumb9,
        width: 480,
        height: 270
    },
    {
        youtubeId: "gAHgjcxVxXM",
        title: "CANON M50 100FPS B ROLL VIDEO by Valere Kissi",
        thumbnail: thumb6,
        width: 480,
        height: 270
    },
    {
        youtubeId: "R7lVdnZofRg",
        title: "JENNY: BMPCC 4K - SIGMA 18-35mm NIGHT VIDEO TEST by Valere Kissi",
        thumbnail: thumb4,
        width: 480,
        height: 270
    },
    {
        youtubeId: "Tukjxfl9JCU",
        title: "Presentazione REHOBOTH ONLUS by Valere Kissi",
        thumbnail: thumb1,
        width: 480,
        height: 270
    },
    {
        youtubeId: "dfbzq54B_og",
        title: "Venezia - Carnevale 2019 - Venice Carnival 2019 - Carnaval de Venise 2019 by Valere Kissi",
        thumbnail: thumb5,
        width: 400,
        height: 267
    }
];
